import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import routes from './router/index'
import index from './lib/index'
import appCore from 'app-core'
import  { setupBasicLocale } from 'app-core'

import gatewayLocale from './lang/meta'

let router = null
let instance = null
async function render(props = {}) {
  const { container } = props

  router = createRouter({
    history: createWebHistory('/'),
    routes
  })
  instance = createApp(App)
  instance.use(appCore, {
    appId: 'app-gateway',
    moduleId: 'pp'
  })
  await Promise.all([setupBasicLocale(gatewayLocale)])
  instance.use(router)
  instance.use(index, router)

  instance.mount(container ? container.querySelector('#app') : '#app')
  console.log(instance)
  // 全局provide $w，让hooks组件里inject可以使用
  instance.provide('$w', instance.config.globalProperties.$w)
  instance.config.warnHandler = function (msg, vm, trace) {
    return false
  }
}
console.log('window.__POWERED_BY_QIANKUN__', window.__POWERED_BY_QIANKUN__)

export async function bootstrap() {}

export function mount(props) {
  render(props)
}

export async function unmount() {
  instance.unmount()
  instance._container.innerHTML = ''
  instance = null
  router = null
  // index.unmount()
}

;((global) => {
  global['home'] = {
    bootstrap,
    mount,
    unmount
  }
})(window)
